{
  "title": "Pagkuha ng recyclables",
  "lead": "Hilingin sa Municipal Environment and Natural Resources Office na kunin sa inyong bahay ang mga naihiwalay na recyclables.",
  "unavailableTitle": "Wala pang pagkuha ng recyclables",
  "unavailableBody": "Ilalathala rito ng opisinang namamahala sa basura ang mga kinukuha nitong materyales at ang mga araw ng pagkuha.",
  "howTitle": "Paano ito gumagana",
  "how1": "Ihiwalay at linisin ang recyclables, saka sabihin sa amin kung ano ang mayroon kayo.",
  "how2": "Pumili ng araw ng pagkuha para sa inyong barangay, o ang susunod na bakanteng araw.",
  "how3": "Iabot ang mga ito sa araw na iyon at itago ang resibo sa app.",
  "materialsTitle": "Ang aming kinukuha",
  "perUnit": "bawat {unit}",
  "daysTitle": "Mga susunod na araw ng pagkuha",
  "noDays": "Wala pang nakatakdang araw ng pagkuha. Puwede pa rin kayong humiling para sa susunod na bakanteng araw.",
  "wholeTown": "Buong bayan",
  "openSlots": "Bukas",
  "full": "Puno na",
  "slotsLeft": "{count} puwesto pa",
  "signInToRequest": "Mag-sign in para humiling ng pagkuha at subaybayan ito rito.",
  "formTitle": "Humiling ng pagkuha",
  "checkForm": "Pakisuri ang mga field na may marka.",
  "whereTitle": "Saan kukunin",
  "address": "Numero ng bahay at kalye, o sitio",
  "addressHint": "Para mahanap kayo ng kukuha.",
  "landmark": "Palatandaan",
  "landmarkPlaceholder": "hal. sa tabi ng kapilya",
  "mapLabel": "Mapa ng lugar na pagkukunan",
  "whenTitle": "Araw ng pagkuha",
  "nextAvailable": "Susunod na bakanteng araw",
  "noDayForBarangay": "Wala pang araw ng pagkuha para sa inyong barangay. Piliin ang susunod na bakanteng araw at itatakda kayo ng opisina.",
  "whatTitle": "Ang inyong iaabot",
  "whatHint": "Ilagay ang tantiya para sa mga materyales na mayroon kayo. Iwanang blangko ang iba.",
  "photoLabel": "Larawan ng recyclables",
  "youTitle": "Paraan para makontak kayo",
  "mobileHint": "Maaaring mag-text o tumawag ang kukuha bago dumating.",
  "notes": "Tala",
  "notesHint": "Anumang dapat malaman ng kukuha, hal. kung saan maghihintay.",
  "send": "Humiling ng pagkuha",
  "sending": "Ipinapadala…",
  "errQty": "Ilagay ang dami na higit sa zero, gaya ng 2 o 2.5.",
  "errNoMaterials": "Maglagay ng kahit isang materyales.",
  "errBarangay": "Piliin ang inyong barangay.",
  "errDay": "Pumili ng araw ng pagkuha.",
  "errAddress": "Ilagay ang address.",
  "errName": "Ilagay ang inyong pangalan.",
  "errConsent": "Pakisang-ayunan ang abiso sa privacy para maipadala ito.",
  "createdTitle": "Naipadala ang hiling",
  "createdScheduled": "Kasama kayo sa araw ng pagkuha sa {date}. Pakihanda ang inyong recyclables.",
  "createdWaiting": "Itatakda kayo ng opisina sa susunod na araw ng pagkuha at ipapaalam sa inyo.",
  "viewPickup": "Subaybayan ang pagkuhang ito",
  "another": "Humiling ng isa pang pagkuha",
  "mineTitle": "Aking mga pagkuha",
  "onDay": "Araw ng pagkuha: {date}",
  "noDayYet": "Naghihintay ng araw ng pagkuha",
  "pickupTitle": "Pagkuha ng recyclables",
  "timelineTitle": "Mga nangyari",
  "detailsTitle": "Mga detalye",
  "officeLabel": "Opisina",
  "expected": "Ang sinabi ninyong iaabot",
  "photoAlt": "Larawan ng recyclables",
  "receiptTitle": "Resibo ng pagkuha",
  "printReceipt": "I-print ang resibo",
  "receiptNo": "Numero ng resibo",
  "reference": "Reference",
  "collectedOn": "Kinuha noong",
  "collector": "Kumuha",
  "collectedItems": "Nakuha",
  "receiptNote": "Itago ang resibong ito para sa inyong talaan.",
  "cancelPickup": "Kanselahin ang pagkuhang ito",
  "cancelTitle": "Kanselahin ang pagkuha?",
  "cancelBody": "Hindi na pupunta ang kukuha para sa recyclables na ito. Puwede kayong humiling ulit kahit kailan.",
  "cancelYes": "Oo, kanselahin",
  "cancelKeep": "Huwag na",
  "cancelledToast": "Nakansela ang pagkuha.",
  "status_requested": "Naghihintay ng araw",
  "status_scheduled": "Nakatakda",
  "status_collected": "Nakuha na",
  "status_missed": "Hindi nakuha",
  "status_cancelled": "Kinansela",
  "adminTitle": "Pagkuha ng recyclables",
  "adminLead": "Itakda ang mga hiling sa araw ng pagkuha, itala ang nakuha kasama ang numero ng resibo, at i-print ang listahan ng kukuha.",
  "tabPickups": "Mga pagkuha",
  "tabRounds": "Mga araw ng pagkuha",
  "tabMaterials": "Mga materyales",
  "tabExport": "I-export",
  "filterAll": "Lahat",
  "dayFilter": "Araw ng pagkuha",
  "anyDay": "Kahit anong araw",
  "searchPlaceholder": "Reference, pangalan, mobile o address",
  "noPickupsTitle": "Walang pagkuha rito",
  "noPickupsBody": "Lalabas dito ang mga hiling ng mga residente.",
  "directions": "Direksyon",
  "requestedOn": "hiniling noong {date}",
  "receiptShort": "Resibo {no}",
  "putOnDay": "Itakda sa isang araw",
  "moveDay": "Ilipat sa ibang araw",
  "markCollected": "Nakuha na",
  "markMissed": "Hindi nakuha",
  "scheduleTitle": "Araw ng pagkuha para sa {ref}",
  "collectionDay": "Araw ng pagkuha",
  "chooseDay": "Pumili ng araw",
  "noRoundForBarangay": "Walang susunod na araw ng pagkuha para sa barangay na ito. Gumawa nito sa Mga araw ng pagkuha.",
  "scheduleHint": "Aabisuhan ang residente.",
  "scheduledToast": "Naitakda sa araw ng pagkuha. Naabisuhan ang residente.",
  "collectedTitle": "Nakuha: {ref}",
  "actualQty": "Ang talagang nakuha",
  "receiptHint": "Ang numero sa resibong ibinigay sa residente. Isang beses lang magagamit ang bawat numero.",
  "errReceipt": "Ilagay ang numero ng resibo.",
  "noteToResident": "Mensahe sa residente",
  "collectedToast": "Naitalang nakuha na. Nasa app na ng residente ang resibo.",
  "missedTitle": "Hindi nakuha: {ref}",
  "missedReason": "Ano ang nangyari",
  "missedHint": "Halimbawa: walang tao sa bahay. Makikita ito ng residente.",
  "errMissedNote": "Sabihin kung ano ang nangyari.",
  "missedToast": "Naitalang hindi nakuha. Naabisuhan ang residente.",
  "newRound": "Bagong araw ng pagkuha",
  "editRound": "I-edit ang araw ng pagkuha",
  "noRoundsTitle": "Wala pang araw ng pagkuha",
  "noRoundsBody": "Gumawa ng araw ng pagkuha para mapili ito ng mga residente.",
  "round_open": "Bukas",
  "round_closed": "Sarado",
  "round_done": "Tapos na",
  "collectorIs": "Kukuha: {name}",
  "noCollector": "Wala pang kukuha",
  "limitIs": "Hanggang {count} pagkuha",
  "noLimit": "Walang limitasyon",
  "roundCounts": "{scheduled} nakatakda · {collected} nakuha · {missed} hindi nakuha",
  "collectorSheet": "Listahan ng kukuha",
  "viewPickups": "Tingnan ang mga pagkuha",
  "barangaysCovered": "Mga barangay na sakop",
  "errBarangays": "Pumili ng kahit isang barangay, o ang buong bayan.",
  "maxPickups": "Pinakamaraming pagkuha",
  "maxHint": "Iwanang blangko kung walang limitasyon.",
  "errMax": "Ilagay ang bilang na 1 o higit pa.",
  "collectorStaff": "Isang kawani",
  "collectorOther": "Ibang tao",
  "staffMember": "Kawani",
  "notYet": "Hindi pa napagpasyahan",
  "collectorName": "Pangalan ng kukuha",
  "collectorNameHint": "Halimbawa, isang katuwang na junkshop.",
  "sheetCount": "{count} pagkuha",
  "sheetEmpty": "Wala pang pagkuha sa araw na ito.",
  "colWhere": "Saan",
  "colWho": "Residente",
  "colMaterials": "Inaasahan",
  "colCollected": "Nakuha",
  "materialsLead": "Ang kinukuha ng opisina. Dito pipili ang mga residente.",
  "addMaterial": "Magdagdag ng materyales",
  "editMaterial": "I-edit ang materyales",
  "noMaterialsTitle": "Wala pang materyales",
  "noMaterialsBody": "Idagdag ang mga recyclables na kinukuha ng inyong opisina.",
  "hidden": "Hindi kinukuha ngayon",
  "moveUp": "Itaas ang {name}",
  "moveDown": "Ibaba ang {name}",
  "editName": "I-edit ang {name}",
  "materialName": "Materyales",
  "materialNameHint": "Halimbawa: PET bottles.",
  "unit": "Yunit",
  "unitHint": "Halimbawa: kg, piraso, sako.",
  "prepNotes": "Paano ito ihahanda",
  "prepNotesHint": "Halimbawa: hinugasan at pinitpit.",
  "acceptNow": "Kinukuha ngayon (mapipili ito ng mga residente)",
  "exportTitle": "I-download ang mga pagkuha",
  "exportLead": "Isang spreadsheet (CSV) ng mga pagkuha ng opisina, kasama ang nakuha at ang mga numero ng resibo.",
  "downloadCsv": "I-download ang CSV",
  "ev_requested": "Naipadala ang hiling",
  "ev_scheduled": "Naitakda sa araw ng pagkuha",
  "ev_collected": "Nakuha na",
  "ev_missed": "Hindi nakuha",
  "ev_cancelled": "Kinansela",
  "addressShort": "Address"
}
